import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage,
    reducer: state => {
        return {
            user: state.user,
            userBak: state.userBak,
            sysConfig: state.sysConfig,
            courseOrder: state.courseOrder,
            studyCourse: state.studyCourse,
        }
    }
})

export default new Vuex.Store({
    state: {
        user: {},
        userBak: [],
        sysConfig: {},
        courseOrder:{},
        logoTitle: {
            imgUrl: 'https://adult-study-test.whxunw.com/img/XunwLogo.f9a93328.png',
            name: '成人教育管理平台'
        },
        config: {},
        studyCourse: {}
    },
    mutations: {
        LOGIN(state, user) {
            state.user = user
        },
        LOGINBAK(state, user) {
            state.userBak = user
        },
        SYSCONFIG(state, data) {
            state.sysConfig = data
        },
        LOGOUT(state) {
            state.sysConfig = null
            state.user = null
            state.menus = []
        },
        SET_COURSE(state, studyCourse) {
            state.studyCourse = studyCourse;
        },
        SET_REGINFO(state, regInfo) {
            state.user.regInfo = regInfo;
        },
        UNSET_COURSE(state) {
            state.studyCourse = null
        },
        PHONE(state,user) {
          state.user = {...state.user,...user}
        },
        CREATE_COURSE_ORDER(state,courseOrder) {
          state.courseOrder = courseOrder
        },
        DESTROY_COURSE_ORDER(state) {
          state.courseOrder = {}
        },
        setLogoTitle(state, logoTitle) {
            state.logoTitle = logoTitle
        },
        setConfig(state, config) {
            // console.log(config);
            Object.keys(config).map(item => {
                if (config[item]) {
                    state.config[item] = config[item]
                }
            })
        }
    },
    actions: {},
    modules: {},
    plugins: [vuexLocal.plugin]
})
